module.exports = __webpack_public_path__ + "static/man_set_8elder.e5f29715.svg";